import { render, staticRenderFns } from "./rankList.vue?vue&type=template&id=79ba0668&scoped=true&"
import script from "./rankList.vue?vue&type=script&lang=js&"
export * from "./rankList.vue?vue&type=script&lang=js&"
import style0 from "./rankList.vue?vue&type=style&index=0&id=79ba0668&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba0668",
  null
  
)

export default component.exports